import React, { useEffect, useRef } from "react";
import "./megascroll.css";


const MegaScrollPage = (props: {
  children: any;
  onActive?: () => void;
  threshold?: number;
  manualScroll?: boolean; // ✅ Add prop
}) => {
  let observer: any;
  const ref: any = useRef(null);

  const onScroll = (entries: any) => {
    if (props.manualScroll ===false && !document.fullscreenElement) {
      for (const entry of entries) {
        if (ref.current && entry.isIntersecting) {
          props.onActive?.();
        }
      }
    }
  };

  useEffect(() => {
    if (props.manualScroll ===false &&  ref.current && props.onActive) {
      observer = new IntersectionObserver(onScroll, {
        threshold: props.threshold || 0.5,
      });
      observer.observe(ref.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref.current,props.manualScroll]); 
  return (
    <div ref={ref} className="ms-item">
      {props.children}
    </div>
  );
};





const MegaScroll = (props: {
  children?: any;
  onChange?: (index: number) => void;
  noFocus?: boolean;
  threshold?: 0.2;
  manualScroll?: boolean; 
}) => {
  const ref: any = useRef(null);
  const childs = React.Children.toArray(props.children);

  useEffect(() => (!props.noFocus ? ref.current?.focus() : () => {}), []);

  return (
    <div ref={ref} className="ms-container">
      {childs.map((child, i) => (
        <MegaScrollPage
          key={i}
          children={child}
          threshold={props.threshold}
          manualScroll={props.manualScroll} // ✅ Pass down
          onActive={props.onChange ? () => props.onChange?.(i) : undefined}
        />
      ))}
    </div>
  );
};

export default MegaScroll;
